// src/api/axios.js
import axios from 'axios'
// 测试环境 开发环境地址
const baseURL = import.meta.env.MODE === 'development' ? 'http://127.0.0.1/console/v1/huixin' : '/console/v1/huixin'

// 创建 axios 实例
const service = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json, text/plain, */*",
    },
    retry: 1, // 默认重试次数
    retryDelay: 1000, // 重试延迟时间(毫秒)
})

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token")
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        console.error("请求拦截错误：", error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        if (response.data.code === 1001) {
            return Promise.reject(new Error(response.data.message))
        }
        if (response.status === 200) {
            return response.data
        } else {
            console.error("API 响应异常：", response)
            return Promise.reject(response)
        }
    },
    async (error) => {
        const originalRequest = error.config

        // 如果是网络错误或超时，并且请求可以重试
        if (!error.response && originalRequest && !originalRequest._retry && originalRequest.retry > 0) {
            originalRequest._retry = true
            originalRequest.retry--

            // 创建新的Promise来处理延迟重试
            return new Promise((resolve) => {
                setTimeout(() => {
                    console.log(`请求失败，正在第${originalRequest.retry + 1}次重试...`)
                    resolve(service(originalRequest))
                }, originalRequest.retryDelay || 1000)
            })
        }

        // 正常错误处理
        if (error.response) {
            const { status, data } = error.response
            let message = "请求出错"
            switch (status) {
                case 400:
                    message = data.message || "请求参数错误"
                    break
                case 401:
                    message = "未授权，请重新登录"
                    localStorage.removeItem("token")
                    // 跳转到登录页
                    window.location.href = '/login.htm'
                    break
                case 403:
                    message = "无权限访问"
                    break
                case 404:
                    message = "资源未找到"
                    break
                case 500:
                    message = "服务器错误"
                    break
                default:
                    message = data.message || `HTTP 错误：${status}`
            }
            console.error("API 请求错误：", message)
            return Promise.reject(new Error(message))
        } else if (error.request) {
            console.error("请求无响应：", error.request)
            return Promise.reject(new Error("网络连接失败，请检查您的网络"))
        } else {
            console.error("请求配置错误：", error.message)
            return Promise.reject(error)
        }
    }
)

export default service